import dynamic from 'next/dynamic';
// import FloatPic from '@elem/compCommon/FloatPic';
import A from './components/A';
import AUS from './components/UsPage/A';
import FixTab from './components/FixTab';
import css from './index.module.scss';
import EfScrollAni from '@/efscrollani';
import PDFActivity from 'elem/compCommon/PillarPageActivities/PDFActivity';
import { useRouter } from 'next/router';

const IndexDynamic = dynamic(() => import('./indexdynamic'), { ssr: true });

export default function VanlifeRoadtrips() {
    const { locale = '', query } = useRouter();
    const now = query?._timer ? new Date(query?._timer).getTime() : new Date().getTime();
    const times: any = {
        us: '2024/09/23 15:00:00 GMT+8',
    };
    const IS_ACTIVE = now >= new Date(times?.[locale] || times.us).getTime();

    const isUs = ['us'].includes(locale);

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }
    return (
        <div className={`cost-saving ${css['cost-saving']}`}>
            <A />
            {locale === 'us' && !IS_ACTIVE && <PDFActivity />}
            {!isUs && <FixTab />}
            <IndexDynamic />
            {/* <FloatPic /> */}
            <style jsx global>
                {`
                    .ecoflow-header {
                        max-width: 100%;
                    }
                    .footer {
                        max-width: 100%;
                        overflow: hidden;
                    }
                `}
            </style>
        </div>
    );
}
